export const QUOTE_TYPES = {
  ADDITIONAL: "additional",
  COMMERCIAL: "commercial",
  DEFAULT: "default",
  ENDORSEMENT: "endorsement",
};

export default QUOTE_TYPES;
